<template>
  <div class="menu-container">
    <div class="menu">
      <h1 class="menu-title">
        {{ title }}
      </h1>

      <MenuItems />
      <OrderBasket v-if="hasProductsInBasket" />
      <OrderSlots v-if="hasProductsInBasket" />
      <OrderDetails v-show="hasProductsInBasket && selectedTimeSlot" />
    </div>
  </div>
</template>

<script>
  import Slice from 'mixins/slice';
  import MenuItems from 'components/order/menu-items';
  import OrderBasket from 'components/order/basket';
  import OrderSlots from 'components/order/slots';
  import OrderDetails from 'components/order/details';
  import ContentHelper from 'mixins/slice-helper';
  import SliceLoader from 'mixins/slice-loader';
  import { mapState, mapGetters } from 'vuex';

  export default {
    name: 'MenuSlice',
    components: { MenuItems, OrderBasket, OrderSlots, OrderDetails },
    mixins: [SliceLoader, ContentHelper, Slice],
    props: {
      hasStartedOrder: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        document: null,
        contentParams: { type: 'menu', uid: '*' }
      };
    },

    computed: {
      ...mapState('order', ['selectedTimeSlot']),
      ...mapGetters('order', ['hasProductsInBasket']),

      title () {
        return this.contentFor(this.document.title);
      }
    }
  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/typo'
  @require '~global/helpers'

  .menu-container
    width: 100%
    display: flex

  .menu
    width: 100%
    max-width: 800px
    margin: 0 auto

  .menu-title
    @extend .t-header
    text-align: center
</style>
